// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk/opsHub/lazy/" + chunkId + "-" + {"141":"04d239","287":"8f3764","479":"e1cd34","545":"22dc1a","768":"4486d6","862":"ab8e49","946":"8baf33","970":"95fb49"}[chunkId] + ".js";
};